module.exports = __webpack_public_path__ + "img/3.b1965c7d.jpg";